<script setup lang="ts">
import type { LucideIcon } from 'lucide-vue-next'

interface Props {
	icon: LucideIcon
	title: string
}

const props = withDefaults(defineProps<Props>(), {
})
</script>

<template>
	<div class="flex flex-col border-[1px] border-solid border-slate-700/60 rounded-xl w-full">
		<!-- Header -->
		<div class="flex items-center justify-between w-full px-4 py-3 border-b border-slate-700/60">
			<div class="flex items-center gap-3">
				<div class="flex-center w-7 h-7 rounded-lg bg-slate-700/50 border border-slate-600/50">
					<props.icon class="lucide-button-icon-xs text-purple-400" />
				</div>
				<span class="text-slate-200 font-medium text-sm md:text-base">{{ props.title }}</span>
			</div>

			<div class="flex items-center gap-2">
				<slot name="headerActions" />
			</div>
		</div>

		<!-- Content -->
		<div class="py-4 w-full flex items-center flex-col gap-4">
			<slot name="content" />
		</div>
	</div>
</template>
